import { render } from "./TestMedicion.vue?vue&type=template&id=56cec8b9"
import script from "./TestMedicion.vue?vue&type=script&lang=js"
export * from "./TestMedicion.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__